export default ({ to, from, next }) => {
    if (localStorage.getItem('userToken')) {
        next('/address')
        
        return false;
    }

    next()
}